import classNames from 'classnames';

import styles from './Textarea.module.scss';

export const Textarea = ({ className = '', ...props }) => (
  <textarea {...props} className={classNames(styles.container, className, 'fs-mask')} />
);
